module.exports = __webpack_public_path__ + "static/media/mark.c8f07c6f.svg";